<template>
  <div :class="['collection-diptych', {'collection-diptych--white': variant === 'white'}]">
    <div class="panel" v-for="(image, index) in images" v-if="index < 2">
      <collection-image :image="buildImgObj(image)" :grayscale="true"></collection-image>  
    </div>
  </div>
</template>

<script>
import Config from 'src/config'
import Prismic from 'prismic.io'
import CollectionImage from 'components/CollectionImage'
import getRespImgSrc from 'assets/js/getRespImgSrc'
export default {
  name: 'Diptych',
  props: ['variant', 'imagesetId'],
  components: {
    CollectionImage
  },
  data () {
    return {
      images: null
    }
  },
  methods: {
    buildImgObj (image) { // image = prismic object
      return {
        type: null,
        src: getRespImgSrc(image, 'image'),
        caption: image.getStructuredText('caption').asHtml(Config.prismic.links),
        alt: image.data['caption'] ? image.getText('caption') : '',
        table: {
          header: image.getText('table--header'),
          text: image.getStructuredText('table--text') ? image.getStructuredText('table--text').asHtml(Config.prismic.links) : null
        }
      }
    },
    getImageset () {
      if (this.imagesetId) {
        Prismic.api(Config.prismic.api_url).then((api) => {
          return api.getByID(this.imagesetId) // An empty query will return all the documents
        }).then((response) => {
          this.images = response.getGroup('imageset.images').value
        }, function (err) {
          console.log('Error getting Imageset: ', err)
        })
      }
    }
  },
  created () {
    this.getImageset()
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.collection-diptych{
  color:$white;
  background:$black;
  padding:9.75% $gutter*1.5;
  margin:$gutter 0 $collection-blockMargin-ns;
  text-align: center;
  
  .panel{
    display:inline-block;
    width:38.899414063%;
    padding:0 $gutter/2;
  }

  // flexbox
  .flexbox &{
    @media (min-width:$bkpt-mobile + 1){
      display:flex;
      justify-content:center;  
    }
  }

  // white
  &.collection-diptych--white{
    padding-top:0;
    padding-bottom:0;
    background:none;
    color:$black;
  }

  // ipad
  @media (max-width:768px){
    .panel{
      display:block;
      float:left;
      width:50%;    
    }
    @include clearFloat();
  }

  // mobile
  @include on_mobile() {
    margin:$collectionMobile-blockMargin-ns 0;
    padding:$collectionMobile-blockMargin-ns $gutter;
    .panel{
      display:block;
      float:none;
      width:$collectionMobile-spreadFrameWidth;
      margin:0 auto;
    }
    .panel + .panel{
      margin-top:$gutter*2;
    }
    figcaption {
      margin-left:0;
      margin-right:0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Collection__Story__Diptych.vue?ef22280e